import React from 'react';

const EmailInboxConfig = {
	settings: {
		layout: { config: {} }
	},
	routes: [
		{
			path: '/apps/email-inbox',
			component: React.lazy(() => import('./index'))
		}
	]
};

export default EmailInboxConfig;
